// extracted by mini-css-extract-plugin
module.exports = {"exclamation":"employeesSingle__exclamation","danger":"employeesSingle__danger"};